/**
 * Simple confirmation prompt for destructive actions. Uses the native dialog
 * for now; can be upgraded to a themed MUI dialog later without changing call
 * sites (the API is promise-based).
 */
export function confirmDelete(message: string): Promise<boolean> {
  return Promise.resolve(window.confirm(message))
}
